@if(loggingPanelModel){<panel [panelInput]="logPanelConfig" (close)="dismiss()">
  <ng-container panel-body>
    <div class="grid-height_container">
      <grid [columns]="gridColumnDefs" [data]="messages" [gridConfigItems]="gridConfigItems"
        [dropdownList]="filterDropdownList" [filterLabel]="filterByLabel"
        (filterChanged)="fnOnFilterChange($event)"> </grid>
    </div>
  </ng-container>
  <ng-container panel-footer>
      <ds-button [buttonInput]="exportButtonConfig" (btnClick)="fnExport()"></ds-button>
    </ng-container>
</panel>}